import React from 'react';
import { Link } from 'react-router-dom';

const ContactPage = () => {
  return (
    <div className="legal-page">
      <div className="back-link-container">
        <Link to="/" className="back-link">&larr; Back to Home</Link>
      </div>

      <h1>Contact Us</h1>
      <p>Last Updated: [Date]</p>
      
      <p>For support, questions, or feedback regarding the Magical Videos service, please reach out to us:</p>
      
      <p><strong>Email:</strong> <a href="mailto:bisbis@fably.fun">[Your Support Email]</a></p>
      
      {/* Add other contact methods if applicable, e.g., Twitter, Discord */}
      {/* <p><strong>Twitter:</strong> <a href="[Your Twitter Link]" target="_blank" rel="noopener noreferrer">@[Your Twitter Handle]</a></p> */}
      
      <p>We aim to respond to inquiries within [Number] business days.</p>
    </div>
  );
};

export default ContactPage; 